var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1728,
    height: 896,
    viewBox: "0 0 1728 896",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_132_79)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1728 896L1662.38 835.52",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1662.38 896L1596.76 835.52",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.76 896L1531.14 835.52",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1531.14 896L1465.52 835.52",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1465.52 896L1399.9 835.52",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.9 896L1334.28 835.52",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1268.66 896L1334.28 835.52",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1268.66 896L1203.04 835.52",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1203.04 896L1137.42 835.52",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.42 896L1071.8 835.52",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.8 896L1006.18 835.52",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.18 896L940.557 835.52",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.557 896L874.937 835.52",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.937 896L809.316 835.52",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.696 896L809.316 835.52",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.696 896L678.076 835.52",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.076 896L612.456 835.52",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.835 896L612.456 835.52",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.835 896L481.215 835.52",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.595 896L481.215 835.52",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.975 896L415.595 835.52",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.975 896L284.354 835.52",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.354 896L218.734 835.52",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.734 896L153.114 835.52",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.114 896L87.4936 835.52",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8734 896L87.4937 835.52",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8734 896L-43.7468 835.52",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M1728 835.52L1662.38 775.04",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M1662.38 835.52L1596.76 775.04",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M1531.14 835.52L1596.76 775.04",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M1531.14 835.52L1465.52 775.04",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M1399.9 835.52L1465.52 775.04",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M1399.9 835.52L1334.28 775.04",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M1334.28 835.52L1268.66 775.04",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M1268.66 835.52L1203.04 775.04",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M1137.42 835.52L1203.04 775.04",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M1071.8 835.52L1137.42 775.04",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M1071.8 835.52L1006.18 775.04",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M940.557 835.52L1006.18 775.04",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M874.937 835.52L940.557 775.04",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M874.937 835.52L809.316 775.04",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M809.316 835.52L743.696 775.04",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M678.076 835.52L743.696 775.04",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M678.076 835.52L612.456 775.04",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M612.456 835.52L546.835 775.04",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M481.215 835.52L546.835 775.04",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M415.595 835.52L481.215 775.04",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M349.975 835.52L415.595 775.04",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M349.975 835.52L284.354 775.04",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M284.354 835.52L218.734 775.04",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M218.734 835.52L153.114 775.04",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M153.114 835.52L87.4936 775.04",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M21.8734 835.52L87.4937 775.04",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M-43.7468 835.52L21.8734 775.04",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1662.38 775.04L1728 714.56",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1662.38 775.04L1596.76 714.56",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1531.14 775.04L1596.76 714.56",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1465.52 775.04L1531.14 714.56",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1465.52 775.04L1399.9 714.56",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1399.9 775.04L1334.28 714.56",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1268.66 775.04L1334.28 714.56",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1268.66 775.04L1203.04 714.56",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1137.42 775.04L1203.04 714.56",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1137.42 775.04L1071.8 714.56",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1071.8 775.04L1006.18 714.56",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M940.557 775.04L1006.18 714.56",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M874.937 775.04L940.557 714.56",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M874.937 775.04L809.316 714.56",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M743.696 775.04L809.316 714.56",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M678.076 775.04L743.696 714.56",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M612.456 775.04L678.076 714.56",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M612.456 775.04L546.835 714.56",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M546.835 775.04L481.215 714.56",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M481.215 775.04L415.595 714.56",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M415.595 775.04L349.975 714.56",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M349.975 775.04L284.354 714.56",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M218.734 775.04L284.354 714.56",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M218.734 775.04L153.114 714.56",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M153.114 775.04L87.4936 714.56",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M21.8734 775.04L87.4937 714.56",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M-43.7468 775.04L21.8734 714.56",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M1728 714.56L1662.38 654.08",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M1662.38 714.56L1596.76 654.08",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M1531.14 714.56L1596.76 654.08",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M1531.14 714.56L1465.52 654.08",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M1399.9 714.56L1465.52 654.08",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M1399.9 714.56L1334.28 654.08",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M1268.66 714.56L1334.28 654.08",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M1203.04 714.56L1268.66 654.08",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M1137.42 714.56L1203.04 654.08",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M1137.42 714.56L1071.8 654.08",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M1071.8 714.56L1006.18 654.08",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M940.557 714.56L1006.18 654.08",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M874.937 714.56L940.557 654.08",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M874.937 714.56L809.316 654.08",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M743.696 714.56L809.316 654.08",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M743.696 714.56L678.076 654.08",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M678.076 714.56L612.456 654.08",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M612.456 714.56L546.835 654.08",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M481.215 714.56L546.835 654.08",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M481.215 714.56L415.595 654.08",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M349.975 714.56L415.595 654.08",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M284.354 714.56L349.975 654.08",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M218.734 714.56L284.354 654.08",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M218.734 714.56L153.114 654.08",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M153.114 714.56L87.4936 654.08",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M21.8734 714.56L87.4937 654.08",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M-43.7468 714.56L21.8734 654.08",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M1662.38 654.08L1728 593.6",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M1662.38 654.08L1596.76 593.6",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M1596.76 654.08L1531.14 593.6",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M1465.52 654.08L1531.14 593.6",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M1399.9 654.08L1465.52 593.6",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M1334.28 654.08L1399.9 593.6",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M1268.66 654.08L1334.28 593.6",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M1268.66 654.08L1203.04 593.6",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M1203.04 654.08L1137.42 593.6",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M1071.8 654.08L1137.42 593.6",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M1006.18 654.08L1071.8 593.6",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M940.557 654.08L1006.18 593.6",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M940.557 654.08L874.937 593.6",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M874.937 654.08L809.316 593.6",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M809.316 654.08L743.696 593.6",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M743.696 654.08L678.076 593.6",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M612.456 654.08L678.076 593.6",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M612.456 654.08L546.835 593.6",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M546.835 654.08L481.215 593.6",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M481.215 654.08L415.595 593.6",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M349.975 654.08L415.595 593.6",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M284.354 654.08L349.975 593.6",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M284.354 654.08L218.734 593.6",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M153.114 654.08L218.734 593.6",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M87.4936 654.08L153.114 593.6",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M87.4937 654.08L21.8734 593.6",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M21.8734 654.08L-43.7468 593.6",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M1728 593.6L1662.38 533.12",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M1662.38 593.6L1596.76 533.12",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M1531.14 593.6L1596.76 533.12",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M1465.52 593.6L1531.14 533.12",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M1399.9 593.6L1465.52 533.12",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M1334.28 593.6L1399.9 533.12",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M1268.66 593.6L1334.28 533.12",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M1203.04 593.6L1268.66 533.12",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M1203.04 593.6L1137.42 533.12",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M1071.8 593.6L1137.42 533.12",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M1071.8 593.6L1006.18 533.12",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M1006.18 593.6L940.557 533.12",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M940.557 593.6L874.937 533.12",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M809.316 593.6L874.937 533.12",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M743.696 593.6L809.316 533.12",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M678.076 593.6L743.696 533.12",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M612.456 593.6L678.076 533.12",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M546.835 593.6L612.456 533.12",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M546.835 593.6L481.215 533.12",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M481.215 593.6L415.595 533.12",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M349.975 593.6L415.595 533.12",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M284.354 593.6L349.975 533.12",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M284.354 593.6L218.734 533.12",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M153.114 593.6L218.734 533.12",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M153.114 593.6L87.4936 533.12",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M87.4937 593.6L21.8734 533.12",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M-43.7468 593.6L21.8734 533.12",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M1728 533.12L1662.38 472.64",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M1662.38 533.12L1596.76 472.64",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M1531.14 533.12L1596.76 472.64",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M1531.14 533.12L1465.52 472.64",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M1465.52 533.12L1399.9 472.64",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M1399.9 533.12L1334.28 472.64",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M1268.66 533.12L1334.28 472.64",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M1268.66 533.12L1203.04 472.64",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M1203.04 533.12L1137.42 472.64",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M1071.8 533.12L1137.42 472.64",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M1006.18 533.12L1071.8 472.64",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M1006.18 533.12L940.557 472.64",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M874.937 533.12L940.557 472.64",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M809.316 533.12L874.937 472.64",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M743.696 533.12L809.316 472.64",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M678.076 533.12L743.696 472.64",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M612.456 533.12L678.076 472.64",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M546.835 533.12L612.456 472.64",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M481.215 533.12L546.835 472.64",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M415.595 533.12L481.215 472.64",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M349.975 533.12L415.595 472.64",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M284.354 533.12L349.975 472.64",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M284.354 533.12L218.734 472.64",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M153.114 533.12L218.734 472.64",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M87.4936 533.12L153.114 472.64",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M21.8734 533.12L87.4937 472.64",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M21.8734 533.12L-43.7468 472.64",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M1728 472.64L1662.38 412.16",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M1662.38 472.64L1596.76 412.16",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M1596.76 472.64L1531.14 412.16",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M1531.14 472.64L1465.52 412.16",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M1399.9 472.64L1465.52 412.16",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M1334.28 472.64L1399.9 412.16",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M1334.28 472.64L1268.66 412.16",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M1268.66 472.64L1203.04 412.16",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M1203.04 472.64L1137.42 412.16",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M1071.8 472.64L1137.42 412.16",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M1006.18 472.64L1071.8 412.16",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M1006.18 472.64L940.557 412.16",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M940.557 472.64L874.937 412.16",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M874.937 472.64L809.316 412.16",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M809.316 472.64L743.696 412.16",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M743.696 472.64L678.076 412.16",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M678.076 472.64L612.456 412.16",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M612.456 472.64L546.835 412.16",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M546.835 472.64L481.215 412.16",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M481.215 472.64L415.595 412.16",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M415.595 472.64L349.975 412.16",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M284.354 472.64L349.975 412.16",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M284.354 472.64L218.734 412.16",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M153.114 472.64L218.734 412.16",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M87.4936 472.64L153.114 412.16",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M87.4937 472.64L21.8734 412.16",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M21.8734 472.64L-43.7468 412.16",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M1662.38 412.16L1728 351.68",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M1596.76 412.16L1662.38 351.68",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M1531.14 412.16L1596.76 351.68",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M1531.14 412.16L1465.52 351.68",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M1465.52 412.16L1399.9 351.68",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M1334.28 412.16L1399.9 351.68",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M1334.28 412.16L1268.66 351.68",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M1268.66 412.16L1203.04 351.68",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M1203.04 412.16L1137.42 351.68",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M1071.8 412.16L1137.42 351.68",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M1006.18 412.16L1071.8 351.68",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M940.557 412.16L1006.18 351.68",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M940.557 412.16L874.937 351.68",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M809.316 412.16L874.937 351.68",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M809.316 412.16L743.696 351.68",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M743.696 412.16L678.076 351.68",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M678.076 412.16L612.456 351.68",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M546.835 412.16L612.456 351.68",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M546.835 412.16L481.215 351.68",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M415.595 412.16L481.215 351.68",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M415.595 412.16L349.975 351.68",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M284.354 412.16L349.975 351.68",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M284.354 412.16L218.734 351.68",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M218.734 412.16L153.114 351.68",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M153.114 412.16L87.4936 351.68",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M87.4937 412.16L21.8734 351.68",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M21.8734 412.16L-43.7468 351.68",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M1662.38 351.68L1728 291.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M1662.38 351.68L1596.76 291.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M1531.14 351.68L1596.76 291.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M1465.52 351.68L1531.14 291.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M1399.9 351.68L1465.52 291.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M1399.9 351.68L1334.28 291.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M1334.28 351.68L1268.66 291.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M1268.66 351.68L1203.04 291.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M1203.04 351.68L1137.42 291.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M1137.42 351.68L1071.8 291.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M1071.8 351.68L1006.18 291.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M1006.18 351.68L940.557 291.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M874.937 351.68L940.557 291.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M874.937 351.68L809.316 291.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M743.696 351.68L809.316 291.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M678.076 351.68L743.696 291.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M678.076 351.68L612.456 291.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M546.835 351.68L612.456 291.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M546.835 351.68L481.215 291.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M415.595 351.68L481.215 291.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M349.975 351.68L415.595 291.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M349.975 351.68L284.354 291.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M284.354 351.68L218.734 291.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M218.734 351.68L153.114 291.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M87.4936 351.68L153.114 291.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M21.8734 351.68L87.4937 291.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M21.8734 351.68L-43.7468 291.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M1728 291.2L1662.38 230.72",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M1662.38 291.2L1596.76 230.72",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M1531.14 291.2L1596.76 230.72",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M1531.14 291.2L1465.52 230.72",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M1399.9 291.2L1465.52 230.72",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M1334.28 291.2L1399.9 230.72",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M1268.66 291.2L1334.28 230.72",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M1268.66 291.2L1203.04 230.72",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M1203.04 291.2L1137.42 230.72",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M1137.42 291.2L1071.8 230.72",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M1071.8 291.2L1006.18 230.72",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M940.557 291.2L1006.18 230.72",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M940.557 291.2L874.937 230.72",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M809.316 291.2L874.937 230.72",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M809.316 291.2L743.696 230.72",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M743.696 291.2L678.076 230.72",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M612.456 291.2L678.076 230.72",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M612.456 291.2L546.835 230.72",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M546.835 291.2L481.215 230.72",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M481.215 291.2L415.595 230.72",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M415.595 291.2L349.975 230.72",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M284.354 291.2L349.975 230.72",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M218.734 291.2L284.354 230.72",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M153.114 291.2L218.734 230.72",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M87.4936 291.2L153.114 230.72",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M87.4937 291.2L21.8734 230.72",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M-43.7468 291.2L21.8734 230.72",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1662.38 230.72L1728 170.24",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1662.38 230.72L1596.76 170.24",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1531.14 230.72L1596.76 170.24",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1465.52 230.72L1531.14 170.24",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1399.9 230.72L1465.52 170.24",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1399.9 230.72L1334.28 170.24",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1334.28 230.72L1268.66 170.24",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1203.04 230.72L1268.66 170.24",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1137.42 230.72L1203.04 170.24",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1071.8 230.72L1137.42 170.24",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1006.18 230.72L1071.8 170.24",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M940.557 230.72L1006.18 170.24",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M940.557 230.72L874.937 170.24",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M809.316 230.72L874.937 170.24",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M743.696 230.72L809.316 170.24",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M743.696 230.72L678.076 170.24",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M612.456 230.72L678.076 170.24",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M546.835 230.72L612.456 170.24",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M546.835 230.72L481.215 170.24",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M481.215 230.72L415.595 170.24",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M349.975 230.72L415.595 170.24",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M284.354 230.72L349.975 170.24",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M218.734 230.72L284.354 170.24",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M218.734 230.72L153.114 170.24",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M153.114 230.72L87.4936 170.24",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M87.4937 230.72L21.8734 170.24",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M21.8734 230.72L-43.7468 170.24",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M1728 170.24L1662.38 109.76",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M1596.76 170.24L1662.38 109.76",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M1531.14 170.24L1596.76 109.76",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M1531.14 170.24L1465.52 109.76",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M1465.52 170.24L1399.9 109.76",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M1334.28 170.24L1399.9 109.76",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M1268.66 170.24L1334.28 109.76",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M1268.66 170.24L1203.04 109.76",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M1137.42 170.24L1203.04 109.76",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M1137.42 170.24L1071.8 109.76",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M1071.8 170.24L1006.18 109.76",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M940.557 170.24L1006.18 109.76",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M874.937 170.24L940.557 109.76",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M874.937 170.24L809.316 109.76",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M809.316 170.24L743.696 109.76",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M678.076 170.24L743.696 109.76",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M612.456 170.24L678.076 109.76",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M546.835 170.24L612.456 109.76",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M546.835 170.24L481.215 109.76",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M481.215 170.24L415.595 109.76",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M349.975 170.24L415.595 109.76",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M349.975 170.24L284.354 109.76",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M218.734 170.24L284.354 109.76",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M153.114 170.24L218.734 109.76",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M153.114 170.24L87.4936 109.76",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M21.8734 170.24L87.4937 109.76",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M-43.7468 170.24L21.8734 109.76",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1662.38 109.76L1728 49.28",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1596.76 109.76L1662.38 49.28",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1531.14 109.76L1596.76 49.28",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1531.14 109.76L1465.52 49.28",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1465.52 109.76L1399.9 49.28",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1334.28 109.76L1399.9 49.28",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1268.66 109.76L1334.28 49.28",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1203.04 109.76L1268.66 49.28",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1203.04 109.76L1137.42 49.28",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1137.42 109.76L1071.8 49.28",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1071.8 109.76L1006.18 49.28",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M940.557 109.76L1006.18 49.28",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M940.557 109.76L874.937 49.28",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M809.316 109.76L874.937 49.28",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M743.696 109.76L809.316 49.28",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M743.696 109.76L678.076 49.28",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M678.076 109.76L612.456 49.28",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M546.835 109.76L612.456 49.28",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M546.835 109.76L481.215 49.28",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M481.215 109.76L415.595 49.28",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M415.595 109.76L349.975 49.28",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M284.354 109.76L349.975 49.28",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M284.354 109.76L218.734 49.28",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M218.734 109.76L153.114 49.28",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M87.4936 109.76L153.114 49.28",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M21.8734 109.76L87.4937 49.28",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M21.8734 109.76L-43.7468 49.28",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1662.38 49.28L1728 -11.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1596.76 49.28L1662.38 -11.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1531.14 49.28L1596.76 -11.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1531.14 49.28L1465.52 -11.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1399.9 49.28L1465.52 -11.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1399.9 49.28L1334.28 -11.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1334.28 49.28L1268.66 -11.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1268.66 49.28L1203.04 -11.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1137.42 49.28L1203.04 -11.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1137.42 49.28L1071.8 -11.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1071.8 49.28L1006.18 -11.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M940.557 49.28L1006.18 -11.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M940.557 49.28L874.937 -11.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M809.316 49.28L874.937 -11.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M743.696 49.28L809.316 -11.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M678.076 49.28L743.696 -11.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M612.456 49.28L678.076 -11.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M612.456 49.28L546.835 -11.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M481.215 49.28L546.835 -11.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M415.595 49.28L481.215 -11.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M349.975 49.28L415.595 -11.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M349.975 49.28L284.354 -11.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M218.734 49.28L284.354 -11.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M153.114 49.28L218.734 -11.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M87.4936 49.28L153.114 -11.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M87.4937 49.28L21.8734 -11.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M-43.7468 49.28L21.8734 -11.2",
    stroke: "#E98BC7",
    strokeOpacity: 0.27,
    strokeWidth: 3.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_132_79"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1728,
    height: 896,
    fill: "white",
    transform: "translate(1728 896) rotate(-180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.06617b9d3a74845860d68ca13e7a0e4d.svg";
export { ForwardRef as ReactComponent };